import { useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { HOURS } from '@sequencehq/utils/dates'
import { PaymentTermsSelect } from 'components/PaymentTerms/PaymentTermsSelect'
// Imported directly from the types module (rather than the `conditions`
// barrel) to avoid a circular import — see the matching note in formatters.tsx.
import { ConditionValueInputComponent } from 'Automations/nodeDefinitions/conditions/conditions.types'

/**
 * Picks a payment terms day count (the `PAYMENT_TERMS` property). Reuses the
 * selector quotes and invoice settings already use, in its standard select
 * form, so the presets and the "Custom" escape hatch read the same here as
 * they do when someone sets the terms on a quote. The account's own default
 * joins the preset list for the same reason — it's the count most quotes
 * carry.
 */
export const PaymentTermsValueInput: ConditionValueInputComponent = ({
  'data-testid': dataTestId,
  value,
  onChange,
  validationErrors
}) => {
  const merchantSettings = useQuery(
    dashboard20240730Client.getMerchantForSequenceAccount,
    undefined,
    { staleTime: 1 * HOURS }
  )
  const accountDefaultDays = merchantSettings.data?.defaultDueDateDays

  return (
    <PaymentTermsSelect
      data-testid={dataTestId ? `${dataTestId}.value` : undefined}
      useFieldVariant
      placeholder="Select terms..."
      value={typeof value === 'number' ? value : undefined}
      onChange={next => onChange({ value: next })}
      customTerms={
        typeof accountDefaultDays === 'number' ? [accountDefaultDays] : []
      }
      validationErrors={validationErrors}
    />
  )
}
